module.exports = __webpack_public_path__ + "img/14.31a61349.png";